import { APP_INITIALIZER, ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { credentialsInterceptor } from './core/interceptors/credentials.interceptor';
import { AuthService } from './core/services/auth.service';
import { RealtimeService } from './core/realtime/realtime.service';
import { RealtimeToastService } from './core/realtime/realtime-toast.service';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { ConfirmationService, MessageService } from 'primeng/api';

registerLocaleData(localeDe);

function initAuth(authService: AuthService): () => Promise<void> {
  return () => authService.loadCurrentUser();
}

// RealtimeService subskribiert in seinem Constructor AuthService.currentUser$ —
// wir müssen ihn nur einmal instanziieren, damit die SignalR-Verbindung aufgebaut
// wird, sobald der Login-Status nicht-null wird. Lazy-Inject in den Komponenten
// reicht nicht: wir wollen die Connection auch dann, wenn der User direkt auf
// einer Seite ohne Dashboard landet (z. B. Anfrage-Detail per Deep-Link).
//
// RealtimeToastService hängt an RealtimeService und mappt jedes Event auf einen
// PrimeNG-Toast — global, unabhängig davon welche Komponente gerade aktiv ist.
function initRealtime(_realtime: RealtimeService, _toasts: RealtimeToastService): () => Promise<void> {
  return () => Promise.resolve();
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'de' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch(), withInterceptors([credentialsInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    MessageService,
    ConfirmationService,
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [AuthService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initRealtime,
      deps: [RealtimeService, RealtimeToastService],
      multi: true,
    },
  ],
};
